export * from './practiceOption'
export * from './previewOption'

export const MAX_PROBLEM_COUNT = 150
export const MAX_CONDITIONAL_PROBLEM_COUNT = 400
export const MAX_WRONG_CLINIC_PAGE_COUNT_BY_ACADEMY_GROUP_WORKBOOK = 15
export const WORKSHEET_EXPORT_OPTIONS = {
  ELEMENT: '문제지',
  QUICK_ANSWER: '빠른정답',
  ANSWER_SOLUTION: '정답해설',
  OMR: 'OMR',
} as const

export const HIDE_TAG_TOP_LIST = [
  'CONCEPT',
  'PRACTICE_TEST',
  'WEAK_DATE',
  'WEAK_CHAPTER',
  'ARITHMETIC',
]
